$(document).ready(function () {
  let filterByFromQuery = $("body").attr("filter_by") || null;
  let startDateFromQuery = $("body").attr("start_date") || null;
  let endDateFromQuery = $("body").attr("end_date") || null;
  let customPeriodFromQuery = $("body").attr("custom_period") || null;
  let prevSelectedPeriodFromQuery =
    $("body").attr("prev_selected_period") || null;
  if (p === "statistic_payment") {
    let totalVipps = 0;
    let totalKort = 0;
    let totalTerminal = 0;
    let totalKontanter = 0;
    let exportDateData = [];
    let exportPaymentMethodData = [];
    setDateAndPeriod(
      startDateFromQuery,
      endDateFromQuery,
      filterByFromQuery,
      customPeriodFromQuery,
      prevSelectedPeriodFromQuery
    );

    handleCustomerIdChange(getPaymentMethod);
    handleCustomPeriodChange(getPaymentMethod);
    handleTopProductGroupChange(getPaymentMethod);
    handleSupplierIdChange(getPaymentMethod);
    handleProductGroupChange(getPaymentMethod);
    handleUserChange(getPaymentMethod);
    handlePlatformChange(getPaymentMethod);
    handlePeriodChange(getPaymentMethod);
    handleDateAndTimeChange(getPaymentMethod);
    handlePreviousButton(getPaymentMethod);
    handleNextButton(getPaymentMethod);
    handleCompareByChange(getPaymentMethod);
    handleProductChange(getPaymentMethod);
    handlePaymentChange(getPaymentMethod);
    handleVatCodeChange(getPaymentMethod);
    handleLocationChange(getPaymentMethod);
    handleCustomDayChange(getPaymentMethod);

    $(document).on("click", "#download-statistic-excel", function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css("width", btnWidth + "px");
      disabledOnClick.prop("disabled", true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      $.ajax({
        url: "/api/v1/private/statistics/download-statistic-excel",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({
          export_date_data: exportDateData,
          export_payment_method_data: exportPaymentMethodData,
          export_type: "payment_method",
          total_vipps: totalVipps,
          total_card: totalKort,
          total_terminal: totalTerminal,
          total_cash: totalKontanter,
        }),
        xhrFields: { responseType: "blob" }, // receive binary data
        success: function (data) {
          if (window.ReactNativeWebView) {
            // Convert blob to base64
            const reader = new FileReader();
            reader.onloadend = function () {
              const base64Data = reader.result.split(',')[1];
              const filename = `Statistikk betalingsmiddel (${startDate.split(" ")[0]} - ${endDate.split(" ")[0]}).xlsx`;

              // Send to React Native
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  action: 'download',
                  data: {
                    base64Data,
                    filename: filename,
                    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                  }
                })
              );
            };
            reader.readAsDataURL(data);
          } else {
            const blob = new Blob([data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `Statistikk betalingsmiddel (${startDate.split(" ")[0]} - ${endDate.split(" ")[0]}).xlsx`;
            link.click();
          }
        },
        error: function () {
          alert("Error generating Excel file");
        },
        complete: function () {
          disabledOnClick.prop("disabled", false);
          disabledOnClick.html("Last ned(excel)");
        },
      });
    });

    $(document).on("click", "#download-statistic-pdf", function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css("width", btnWidth + "px");
      disabledOnClick.prop("disabled", true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      var svg = chartComponent.getSVG();

      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var img = new Image();

      img.onload = function () {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        var pngData = canvas.toDataURL("image/png"); // base64 PNG

        // Send AJAX after PNG is ready
        $.ajax({
          url: "/api/v1/private/statistics/download-statistic-pdf",
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify({
            export_date_data: exportDateData,
            export_payment_method_data: exportPaymentMethodData,
            export_type: "payment_method",
            total_vipps: totalVipps,
            total_card: totalKort,
            total_terminal: totalTerminal,
            total_cash: totalKontanter,
            chart_png: pngData,
          }),
          xhrFields: { responseType: "blob" },
          success: function (data) {
            if (window.ReactNativeWebView) {
              // Convert blob to base64
              const reader = new FileReader();
              reader.onloadend = function () {
                const base64Data = reader.result.split(',')[1]; // Remove data:*/*;base64, prefix
                const filename = `Statistikk betalingsmiddel (${startDate.split(" ")[0]} - ${endDate.split(" ")[0]}).pdf`;

                // Send to React Native
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    action: 'download',
                    data: {
                      base64Data,
                      filename: filename,
                      mimeType: 'application/pdf'
                    }
                  })
                );
              };
              reader.readAsDataURL(data);
            } else {
              const blob = new Blob([data], { type: "application/pdf" });
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = `Statistikk betalingsmiddel (${startDate.split(" ")[0]} - ${endDate.split(" ")[0]}).pdf`;
              link.click();
            }
          },
          error: function () {
            alert("Error generating PDF");
            disabledOnClick.prop("disabled", false);
            disabledOnClick.html("Last ned(pdf)");
          },
          complete: function () {
            disabledOnClick.prop("disabled", false);
            disabledOnClick.html("Last ned(pdf)");
          }
        });
      };

      img.src =
        "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
    });

    function eventLineChart(seriesData, interval = null) {
      const { legendText, previousLegendText } = getLegendTexts(
        compareBy,
        startDate
      );
      let categories = seriesData.map((item) => item.name); // Extract dates for x-axis categories
      exportDateData = categories;
      // Prepare the series array
      let series = [
        {
          name: "Vipps",
          data: seriesData.map((item) => parseFloat(item.data[0][0])), // First line of Vipps
          stack: "Vipps",
        },
        {
          name: "Kort",
          data: seriesData.map((item) => parseFloat(item.data[0][1])), // First line of Kort
          stack: "Kort",
        },
        {
          name: "Terminal",
          data: seriesData.map((item) => parseFloat(item.data[0][2])), // First line of Terminal
          stack: "Terminal",
          color: "grey",
        },
        {
          name: "Kontanter",
          data: seriesData.map((item) => parseFloat(item.data[0][3])), // First line of Kontanter
          stack: "Kontanter",
        },
      ];

      exportPaymentMethodData = series;
      // Conditionally add last week and last year data if compareBy is not null or "0"
      if (compareBy && compareBy !== "0") {
        series = [
          {
            name: `Vipps (${formattedPriceToShowForStatistic(
              seriesData.reduce(
                (sum, item) => sum + parseFloat(item.data[0][0]),
                0
              )
            )}) ${legendText}`,
            data: seriesData.map((item) => parseFloat(item.data[0][0])),
            stack: "Vipps",
          },
          {
            name: `Vipps forrige ${getPeriodTranslation(
              compareBy ?? "",
              startDate
            )} (${formattedPriceToShowForStatistic(
              seriesData.reduce(
                (sum, item) => sum + parseFloat(item.data[1][0]),
                0
              )
            )}) ${previousLegendText}`,
            data: seriesData.map((item) => parseFloat(item.data[1][0])),
            stack: "Vipps",
          },

          {
            name: `Kort (${formattedPriceToShowForStatistic(
              seriesData.reduce(
                (sum, item) => sum + parseFloat(item.data[0][1]),
                0
              )
            )}) ${legendText}`,
            data: seriesData.map((item) => parseFloat(item.data[0][1])),
            stack: "Kort",
          },
          {
            name: `Kort forrige ${getPeriodTranslation(
              compareBy ?? "",
              startDate
            )} (${formattedPriceToShowForStatistic(
              seriesData.reduce(
                (sum, item) => sum + parseFloat(item.data[1][1]),
                0
              )
            )}) ${previousLegendText}`,
            data: seriesData.map((item) => parseFloat(item.data[1][1])),
            stack: "Kort",
          },

          {
            name: `Terminal (${formattedPriceToShowForStatistic(
              seriesData.reduce(
                (sum, item) => sum + parseFloat(item.data[0][2]),
                0
              )
            )}) ${legendText}`,
            data: seriesData.map((item) => parseFloat(item.data[0][2])),
            stack: "Terminal",
          },
          {
            name: `Terminal forrige ${getPeriodTranslation(
              compareBy ?? "",
              startDate
            )} (${formattedPriceToShowForStatistic(
              seriesData.reduce(
                (sum, item) => sum + parseFloat(item.data[1][2]),
                0
              )
            )}) ${previousLegendText}`,
            data: seriesData.map((item) => parseFloat(item.data[1][2])),
            stack: "Terminal",
          },

          {
            name: `Kontanter (${formattedPriceToShowForStatistic(
              seriesData.reduce(
                (sum, item) => sum + parseFloat(item.data[0][3]),
                0
              )
            )}) ${legendText}`,
            data: seriesData.map((item) => parseFloat(item.data[0][3])),
            stack: "Kontanter",
          },
          {
            name: `Kontanter forrige ${getPeriodTranslation(
              compareBy ?? "",
              startDate
            )} (${formattedPriceToShowForStatistic(
              seriesData.reduce(
                (sum, item) => sum + parseFloat(item.data[1][3]),
                0
              )
            )}) ${previousLegendText}`,
            data: seriesData.map((item) => parseFloat(item.data[1][3])),
            stack: "Kontanter",
          },
        ];
      }

      // Render the chart
      chartComponent = Highcharts.chart("event-line-graph", {
        chart: { type: "column" },
        title: {
          text: null,
        },
        exporting: { enabled: false },
        plotOptions: {
          series: {
            lineWidth: 2, // Adjust line width as needed
            stacking: "normal", // Enable stacking of columns in the same group
          },
        },
        xAxis: {
          categories: categories,
          labels: {
            formatter: function () {
              if (customPeriod === "day") {
                return Highcharts.dateFormat(
                  "%e/%b",
                  new Date(this.value).getTime()
                );
              } else if (customPeriod === "week") {
                return "Uke " + this.value;
              } else if (customPeriod === "month") {
                return Highcharts.dateFormat(
                  "%B %Y",
                  new Date(this.value).getTime()
                );
              } else {
                return this.value;
              }
            },
          },
        },
        credits: { enabled: false },
        yAxis: {
          title: {
            text: " ",
          },
        },
        series: series,
        tooltip: {
          formatter: function () {
            let tooltipText;
            let tooltipDate;
            let tooltipWeek;

            if (this.series.name.includes("uke")) {
              let date = moment(this.x);
              date.subtract(1, "week");
              tooltipDate = date.valueOf();
            } else if (this.series.name.includes("forrige")) {
              let date = moment(this.x);
              date.subtract(1, "year");
              tooltipDate = date.valueOf();
            } else {
              tooltipDate = this.x;
            }

            if (this.series.name.includes("uke")) {
              tooltipWeek = parseInt(this.x) - 1;
            } else {
              tooltipWeek = this.x;
            }

            if (startDate.split(" ")[0] == endDate.split(" ")[0]) {
              tooltipText =
                "<b>" +
                Highcharts.dateFormat("%H:%M, %b %e", tooltipDate) +
                "</b><br/>" +
                this.series.name +
                " : " +
                formattedPriceToShowForStatistic(this.y);
            } else if (customPeriod === "week") {
              tooltipText =
                "<b>" +
                "Uke" +
                " " +
                tooltipWeek +
                "</b><br/>" +
                this.series.name +
                " : " +
                formattedPriceToShowForStatistic(this.y);
            } else if (customPeriod === "month") {
              tooltipText =
                "<b>" +
                Highcharts.dateFormat("%B - %Y", tooltipDate) +
                "</b><br/>" +
                this.series.name +
                " : " +
                formattedPriceToShowForStatistic(this.y);
            } else {
              tooltipText =
                "<b>" +
                Highcharts.dateFormat("%A, %b %e, %Y", tooltipDate) +
                "</b><br/>" +
                this.series.name +
                " : " +
                formattedPriceToShowForStatistic(this.y);
            }
            return tooltipText;
          },
        },
      });
    }

    function toggleCustomDatePicker() {
      let customDatePicker = $(".custom-date-picker");

      if (period === "custom") {
        customDatePicker.show();
      } else {
        customDatePicker.hide();
      }
    }

    function getPaymentMethod(
      startDate,
      endDate,
      period = null,
      supplierId = null,
      productGroupUniqueId = null,
      locationId = 'all',
      userId = null,
      platform = "all",
      customPeriod,
      topProductGroupUniqueId = 0,
      customerId,
      compareBy = null,
      productId = 0,
      vatCode = 0,
      paymentMethod = 0,
      selectedDay = null
    ) {
      $.ajax({
        type: "POST",
        url: "/ajax/statistic_payment/search",
        data: {
          startDate,
          endDate,
          period,
          supplierId,
          productGroupUniqueId,
          locationId,
          userId,
          platform,
          customPeriod,
          topProductGroupUniqueId,
          customerId,
          compareBy,
          productId,
          vatCode,
          paymentMethod,
          selectedDay,
        },
      })
        .done(function (data) {
          if (data.paymentCounts) {
            $("#key-figure-vipps").text(
              formattedPriceToShowForStatistic(data.paymentCounts.vippsCount)
            );
            $("#key-figure-column-1").attr(
              "data-content",
              parseFloat(data.paymentCounts.vippsCount, 3)
                .toString()
                .replace(".", ",")
            );
            $("#key-figure-card").text(
              formattedPriceToShowForStatistic(data.paymentCounts.cardCount)
            );
            $("#key-figure-column-2").attr(
              "data-content",
              parseFloat(data.paymentCounts.cardCount, 3)
                .toString()
                .replace(".", ",")
            );
            $("#key-figure-terminal").text(
              formattedPriceToShowForStatistic(data.paymentCounts.terminalCount)
            );
            $("#key-figure-column-3").attr(
              "data-content",
              parseFloat(data.paymentCounts.terminalCount, 3)
                .toString()
                .replace(".", ",")
            );
            $("#key-figure-cash").text(
              formattedPriceToShowForStatistic(data.paymentCounts.cashCount)
            );
            $("#key-figure-column-4").attr(
              "data-content",
              parseFloat(data.paymentCounts.cashCount, 3)
                .toString()
                .replace(".", ",")
            );

            totalVipps = data.paymentCounts.vippsCount;
            totalKort = data.paymentCounts.cardCount;
            totalTerminal = data.paymentCounts.terminalCount;
            totalKontanter = data.paymentCounts.cashCount;
          } else {
            $("#key-figure-vipps").text("0");
            $("#key-figure-card").text("0");
            $("#key-figure-terminal").text("0");
            $("#key-figure-cash").text("0");
          }
          if (data.data) {
            eventLineChart(data.data);
          }
          let aTags = $(".statistic-tab-group a");
          aTags.each(function () {
            let oldHref = $(this).attr("href").split("?")[0];
            let newHref =
              oldHref +
              `?filter_by=${period}&custom_period=${customPeriod}&prev_selected_period=${prevSelectedPeriod}&start_date=${startDate}&end_date=${endDate}`;
            $(this).prop("href", newHref);
          });
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    function displayGraphDynamically(durationOfstartAndEndDate) {
      if (isMobile) {
        if (durationOfstartAndEndDate <= 7) {
          customPeriod = "day";
          $("#custom-period option[value='day']").prop("disabled", false);
          $("#custom-period option[value='day']").prop("selected", true);
          $("#custom-period option[value='week']").prop("disabled", false);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").removeClass("disabledOption");
          $("#custom-period option[value='week']").removeClass(
            "disabledOption"
          );
        } else if (
          durationOfstartAndEndDate >= 8 &&
          durationOfstartAndEndDate < 49
        ) {
          //week
          customPeriod = "week";
          $(`#custom-period option[value="week"]`).prop("selected", true);
          $("#custom-period option[value='week']").prop("disabled", false);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='day']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").addClass("disabledOption");
          $("#custom-period option[value='week']").removeClass(
            "disabledOption"
          );
        } else {
          //month
          customPeriod = "month";
          $(`#custom-period option[value="week"]`).prop("selected", false);
          $(`#custom-period option[value="month"]`).prop("selected", true);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='day']").prop("disabled", true);
          $("#custom-period option[value='week']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").addClass("disabledOption");
          $("#custom-period option[value='week']").addClass("disabledOption");
        }
      } else if (isTablet) {
        if (durationOfstartAndEndDate <= 180) {
          //day
          customPeriod = "day";
          $("#custom-period option[value='day']").prop("disabled", false);
          $("#custom-period option[value='day']").prop("selected", true);
          $("#custom-period option[value='week']").prop("disabled", false);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").removeClass("disabledOption");
          $("#custom-period option[value='week']").removeClass(
            "disabledOption"
          );
        } else if (
          durationOfstartAndEndDate >= 181 &&
          durationOfstartAndEndDate < 365
        ) {
          //week
          customPeriod = "week";
          $(`#custom-period option[value="week"]`).prop("selected", true);
          $("#custom-period option[value='week']").prop("disabled", false);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='day']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").addClass("disabledOption");
          $("#custom-period option[value='week']").removeClass(
            "disabledOption"
          );
        } else {
          //month
          customPeriod = "month";
          $(`#custom-period option[value="week"]`).prop("selected", false);
          $(`#custom-period option[value="month"]`).prop("selected", true);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='day']").prop("disabled", true);
          $("#custom-period option[value='week']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").addClass("disabledOption");
          $("#custom-period option[value='week']").addClass("disabledOption");
        }
      } else {
        if (durationOfstartAndEndDate <= 180) {
          //day
          customPeriod = "day";
          $("#custom-period option[value='day']").prop("disabled", false);
          $("#custom-period option[value='day']").prop("selected", true);
          $("#custom-period option[value='week']").prop("disabled", false);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").removeClass("disabledOption");
          $("#custom-period option[value='week']").removeClass(
            "disabledOption"
          );
        } else if (
          durationOfstartAndEndDate >= 181 &&
          durationOfstartAndEndDate < 365
        ) {
          //week
          customPeriod = "week";
          $(`#custom-period option[value="week"]`).prop("selected", true);
          $("#custom-period option[value='week']").prop("disabled", false);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='day']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").addClass("disabledOption");
          $("#custom-period option[value='week']").removeClass(
            "disabledOption"
          );
        } else {
          //month
          customPeriod = "month";
          $(`#custom-period option[value="week"]`).prop("selected", false);
          $(`#custom-period option[value="month"]`).prop("selected", true);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='day']").prop("disabled", true);
          $("#custom-period option[value='week']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").addClass("disabledOption");
          $("#custom-period option[value='week']").addClass("disabledOption");
        }
      }
    }

    getPaymentMethod(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod
    );
    toggleCustomDatePicker();
  }
});
